import { createApp, createVNode, type App as AppType, type Component, render } from 'vue';
import 'iconify-icon';
import { createPinia } from 'pinia';
import VueDragscroll from 'vue-dragscroll';
import Toast, { POSITION } from 'vue-toastification';
import 'vue-toastification/dist/index.css';

import router from '@/router';

import App from './App.vue';
import './index.css';

import Glue from './glue-event-handlers';
import { useConnectionStore } from '@/stores/connection';
import { useRootStore } from '@/stores/root';
import { createGettext } from 'vue3-gettext';
import LegacyEventArtists from '@/components/LegacyEventArtists.vue';

Glue();

const gettext = createGettext({
  availableLanguages: {
    en: 'English',
  },
  defaultLanguage: 'en',
});

const pinia = createPinia();

const mountComponent = (app: AppType, elem: HTMLElement, component: Component, props: Record<string, unknown>) => {
  const vNode = createVNode(component, props);
  vNode.appContext = app._context;
  render(vNode, elem);
  return vNode.component;
};

const app = createApp(App)
  .use(gettext)
  .use(pinia)
  .use(router)
  .use(VueDragscroll)
  .use(Toast, {
    position: POSITION.TOP_RIGHT,
    timeout: 3000,
    hideProgressBar: true,
    closeButton: false,
    transition: 'Vue-Toastification__fade',
  });

const rootStore = useRootStore();
const connectionStore = useConnectionStore();
connectionStore.init({ apiBase: rootStore.apiBase });
connectionStore.initAttachmentsClient();

app.mount('#vp-app-new');

const eventArtistsElement = document.getElementById('event-artists-vue-component');
if (eventArtistsElement) {
  const props = [...eventArtistsElement.attributes].filter(attr => attr.name[0] === ':').reduce((props, attr) => {
    props[attr.name.slice(1)] = attr.value;
    return props;
  }, {} as Record<string, unknown>);
  mountComponent(app, eventArtistsElement, LegacyEventArtists, props);
}
